import styled from "styled-components";
import { theme } from "../../../config";
import { SelectParams } from "./types";

export const Wrapper = styled.div`
  height: 100%;
  width: 100%;

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    color: ${theme.colors.neutral.black2};
    border-radius: 4px;
    width: ${(props: SelectParams) => props.width || "100%"};
    padding-top: 5px;
    ${theme.defaultInputStyle}
    @media ${theme.breakpoints.mobileAndTablet} {
      height: 30px;
      font-size: 12.6px;
      line-height: 16px;
      padding-top: 0;
      width: 100%;
    }
    border: 1px solid
    ${({ error }: SelectParams) => (error ? '#E3170A' : theme.colors.borderColor)};
  }

  .ant-select-disabled.ant-select:not(.ant-select-customize-input)
  .ant-select-selector {
    color: ${theme.colors.neutral.black3};
    background-color: ${theme.colors.neutral.black7};
    border: 1px solid #AAAAAA;
  }

.ant-select-selector:disabled {
  border: 1px solid ${theme.colors.neutral.black3};
}

.ant-select:not(.ant-select-customize-input)
  .ant-select-selector:hover:enabled {
  border: 1px solid ${theme.colors.secondary};
}
`;